// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Contracts page */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.add-btn {
  background: #5865f2;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.add-btn:hover {
  background: #4752c4;
}

.filter-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.filter-tabs button {
  background: #2f3136;
  color: #b9bbbe;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.filter-tabs button.active,
.filter-tabs button:hover {
  background: #5865f2;
  color: white;
}

.contracts-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.contract-card {
  background: #2f3136;
  border-radius: 8px;
  padding: 15px;
  border-left: 4px solid #72767d;
  transition: transform 0.2s, box-shadow 0.2s;
}

.contract-card:hover {
  transform: translateX(3px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.contract-card.draft {
  border-left-color: #faa61a;
}

.contract-card.active {
  border-left-color: #43b581;
}

.contract-card.terminated {
  border-left-color: #f04747;
  opacity: 0.8;
}

.contract-card.expired {
  border-left-color: #72767d;
  opacity: 0.7;
}

.contract-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.contract-title {
  color: #fff;
  margin: 0;
  font-size: 16px;
}

.status-badge {
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: bold;
}

.status-badge.draft { background: #faa61a; color: black; }
.status-badge.active { background: #43b581; color: white; }
.status-badge.terminated { background: #f04747; color: white; }
.status-badge.expired { background: #72767d; color: white; }

.contract-parties {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  font-size: 13px;
}

.party.dominant {
  color: #f04747;
}

.party.submissive {
  color: #5865f2;
}

.party-divider {
  color: #72767d;
}

.contract-safeword {
  background: #202225;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 12px;
  color: #dcddde;
  margin-bottom: 8px;
}

.contract-safeword .safeword-label {
  color: #f04747;
  font-weight: bold;
}

.contract-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  font-size: 12px;
  color: #72767d;
  margin-bottom: 10px;
}

.contract-actions {
  display: flex;
  gap: 8px;
  padding-top: 10px;
  border-top: 1px solid #40444b;
}

.action-btn {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
}

.action-btn.view {
  background: #40444b;
  color: #fff;
}

.action-btn.view:hover {
  background: #4f545c;
}

.action-btn.sign {
  background: #43b581;
  color: white;
}

.action-btn.sign:hover {
  background: #3aa070;
}

.action-btn.edit {
  background: #5865f2;
  color: white;
}

.action-btn.edit:hover {
  background: #4752c4;
}

.action-btn.terminate {
  background: #f04747;
  color: white;
}

.action-btn.terminate:hover {
  background: #d83c3c;
}

.no-contracts {
  text-align: center;
  color: #72767d;
  padding: 40px;
}

/* Detail Modal */
.detail-modal {
  max-width: 600px;
}

.detail-section {
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #40444b;
}

.detail-section:last-of-type {
  border-bottom: none;
}

.detail-section h4 {
  color: #b9bbbe;
  margin: 0 0 8px 0;
  font-size: 12px;
  text-transform: uppercase;
}

.detail-section p {
  color: #dcddde;
  margin: 4px 0;
  font-size: 14px;
}

.terms-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.terms-list li {
  color: #dcddde;
  font-size: 13px;
  padding: 6px 0;
  border-bottom: 1px solid #40444b;
}

.terms-list li:last-child {
  border-bottom: none;
}

.terms-list li::before {
  content: '\\2022';
  color: #5865f2;
  margin-right: 8px;
}

.limits-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.limit-tag {
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 11px;
}

.limit-tag.hard {
  background: #f04747;
  color: white;
}

.limit-tag.soft {
  background: #faa61a;
  color: black;
}

.safeword-display {
  background: #202225;
  padding: 8px 12px;
  border-radius: 4px;
  color: #f04747;
  font-weight: bold;
  font-size: 16px;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: #36393f;
  border-radius: 8px;
  padding: 20px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal h2 {
  color: #fff;
  margin: 0 0 20px 0;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  color: #b9bbbe;
  margin-bottom: 5px;
  font-size: 13px;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #40444b;
  border-radius: 4px;
  background: #2f3136;
  color: #fff;
  font-size: 14px;
}

.form-group textarea {
  min-height: 80px;
  resize: vertical;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.cancel-btn {
  padding: 10px 20px;
  background: #40444b;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.submit-btn {
  padding: 10px 20px;
  background: #5865f2;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.submit-btn:hover {
  background: #4752c4;
}

.loading-container {
  display: flex;
  justify-content: center;
  padding: 40px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #40444b;
  border-top-color: #5865f2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Contracts.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA,sBAAsB,mBAAmB,EAAE,YAAY,EAAE;AACzD,uBAAuB,mBAAmB,EAAE,YAAY,EAAE;AAC1D,2BAA2B,mBAAmB,EAAE,YAAY,EAAE;AAC9D,wBAAwB,mBAAmB,EAAE,YAAY,EAAE;;AAE3D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":["/* Contracts page */\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.add-btn {\n  background: #5865f2;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n}\n\n.add-btn:hover {\n  background: #4752c4;\n}\n\n.filter-tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.filter-tabs button {\n  background: #2f3136;\n  color: #b9bbbe;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.filter-tabs button.active,\n.filter-tabs button:hover {\n  background: #5865f2;\n  color: white;\n}\n\n.contracts-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.contract-card {\n  background: #2f3136;\n  border-radius: 8px;\n  padding: 15px;\n  border-left: 4px solid #72767d;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.contract-card:hover {\n  transform: translateX(3px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.contract-card.draft {\n  border-left-color: #faa61a;\n}\n\n.contract-card.active {\n  border-left-color: #43b581;\n}\n\n.contract-card.terminated {\n  border-left-color: #f04747;\n  opacity: 0.8;\n}\n\n.contract-card.expired {\n  border-left-color: #72767d;\n  opacity: 0.7;\n}\n\n.contract-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.contract-title {\n  color: #fff;\n  margin: 0;\n  font-size: 16px;\n}\n\n.status-badge {\n  padding: 3px 10px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: bold;\n}\n\n.status-badge.draft { background: #faa61a; color: black; }\n.status-badge.active { background: #43b581; color: white; }\n.status-badge.terminated { background: #f04747; color: white; }\n.status-badge.expired { background: #72767d; color: white; }\n\n.contract-parties {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 8px;\n  font-size: 13px;\n}\n\n.party.dominant {\n  color: #f04747;\n}\n\n.party.submissive {\n  color: #5865f2;\n}\n\n.party-divider {\n  color: #72767d;\n}\n\n.contract-safeword {\n  background: #202225;\n  padding: 6px 10px;\n  border-radius: 4px;\n  font-size: 12px;\n  color: #dcddde;\n  margin-bottom: 8px;\n}\n\n.contract-safeword .safeword-label {\n  color: #f04747;\n  font-weight: bold;\n}\n\n.contract-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n  font-size: 12px;\n  color: #72767d;\n  margin-bottom: 10px;\n}\n\n.contract-actions {\n  display: flex;\n  gap: 8px;\n  padding-top: 10px;\n  border-top: 1px solid #40444b;\n}\n\n.action-btn {\n  padding: 8px 12px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 12px;\n}\n\n.action-btn.view {\n  background: #40444b;\n  color: #fff;\n}\n\n.action-btn.view:hover {\n  background: #4f545c;\n}\n\n.action-btn.sign {\n  background: #43b581;\n  color: white;\n}\n\n.action-btn.sign:hover {\n  background: #3aa070;\n}\n\n.action-btn.edit {\n  background: #5865f2;\n  color: white;\n}\n\n.action-btn.edit:hover {\n  background: #4752c4;\n}\n\n.action-btn.terminate {\n  background: #f04747;\n  color: white;\n}\n\n.action-btn.terminate:hover {\n  background: #d83c3c;\n}\n\n.no-contracts {\n  text-align: center;\n  color: #72767d;\n  padding: 40px;\n}\n\n/* Detail Modal */\n.detail-modal {\n  max-width: 600px;\n}\n\n.detail-section {\n  margin-bottom: 15px;\n  padding-bottom: 15px;\n  border-bottom: 1px solid #40444b;\n}\n\n.detail-section:last-of-type {\n  border-bottom: none;\n}\n\n.detail-section h4 {\n  color: #b9bbbe;\n  margin: 0 0 8px 0;\n  font-size: 12px;\n  text-transform: uppercase;\n}\n\n.detail-section p {\n  color: #dcddde;\n  margin: 4px 0;\n  font-size: 14px;\n}\n\n.terms-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.terms-list li {\n  color: #dcddde;\n  font-size: 13px;\n  padding: 6px 0;\n  border-bottom: 1px solid #40444b;\n}\n\n.terms-list li:last-child {\n  border-bottom: none;\n}\n\n.terms-list li::before {\n  content: '\\2022';\n  color: #5865f2;\n  margin-right: 8px;\n}\n\n.limits-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.limit-tag {\n  padding: 3px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n}\n\n.limit-tag.hard {\n  background: #f04747;\n  color: white;\n}\n\n.limit-tag.soft {\n  background: #faa61a;\n  color: black;\n}\n\n.safeword-display {\n  background: #202225;\n  padding: 8px 12px;\n  border-radius: 4px;\n  color: #f04747;\n  font-weight: bold;\n  font-size: 16px;\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: #36393f;\n  border-radius: 8px;\n  padding: 20px;\n  width: 100%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.modal h2 {\n  color: #fff;\n  margin: 0 0 20px 0;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n.form-group label {\n  display: block;\n  color: #b9bbbe;\n  margin-bottom: 5px;\n  font-size: 13px;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #40444b;\n  border-radius: 4px;\n  background: #2f3136;\n  color: #fff;\n  font-size: 14px;\n}\n\n.form-group textarea {\n  min-height: 80px;\n  resize: vertical;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.cancel-btn {\n  padding: 10px 20px;\n  background: #40444b;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.submit-btn {\n  padding: 10px 20px;\n  background: #5865f2;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.submit-btn:hover {\n  background: #4752c4;\n}\n\n.loading-container {\n  display: flex;\n  justify-content: center;\n  padding: 40px;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #40444b;\n  border-top-color: #5865f2;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
